import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useAuth } from "../../context/AuthContext";
import { useAlert } from "../../context/AlertContext";
import { useLoading } from "../../context/LoadingContext";
import { autoDisplayValue } from "../../commons/FormatValue";
import { getServiceRequest } from "../../commons/ServiceRequest";
import { initializeSetOption } from "../../utils/InitializeSetDefault";
import {
  FloatingControlComponent,
  SearchSelectComponent
} from "../FormComponent";
import { filteredItemInArray, findItemInArray } from "../../utils/ManageArray";
import ConfirmModal from "../ConfirmModal";

import ParentBomsService from "../../services/parentboms.service";
import CardDisplayComponent from "../CardDisplayComponent";

const ParentBomForm = ({ onSubmitCallback }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [showModal, setShowModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [parentBoms, setParentBoms] = useState([]);
  const defaultData = {
    Id: "",
    Item_Parent_Id: "",
    Bom_Type: "",
    Com_Code: user.Com_Code
  };
  const [data, setData] = useState({ Array: [defaultData] });
  const rowData = data.Array?.[0];
  const inputField = [
    {
      name: "Item_Parent_Id",
      label: "รหัสสินค้า",
      type: "select",
      filterBy: ["Item.Item_Code"],
      options: initializeSetOption({
        key: "Item_Parent_Id",
        label: "Item.Item_Code",
        dataset: parentBoms
      })
    },
    {
      name: "Item.Item_Name_TH",
      label: "ชื่อสินค้า",
      size: 6,
      findValue: {
        data: parentBoms,
        key: "Item_Parent_Id",
        value: "Item_Parent_Id"
      }
    },
    {
      name: "Bom_Type",
      label: "ชนิด BOM",
      type: "select",
      noneAsync: true,
      options: [
        { value: "FG", label: "FG" },
        { value: "DRAFT", label: "Draft" }
      ]
    }
  ];

  const handleChange = (name, value) => {
    const findData = findItemInArray(parentBoms, name, value);
    setData({
      Array: [
        {
          Id: name === "Item_Parent_Id" ? findData.Id : rowData?.Id,
          Item_Parent_Id:
            name === "Item_Parent_Id"
              ? findData.Item_Parent_Id
              : rowData?.Item_Parent_Id,
          Bom_Type: name === "Item_Parent_Id" ? findData.Bom_Type : value,
          Com_Code:
            name === "Item_Parent_Id" ? findData.Com_Code : rowData?.Com_Code
        }
      ]
    });
  };

  const handleValidated = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (!form.checkValidity()) {
      event.stopPropagation();
      setValidated(true);
    } else {
      setShowModal(true);
    }
  };

  const handleSubmit = (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal(showCallback);

    if (dataCallback) {
      const arrData = dataCallback.Array[0];
      onSubmitCallback(arrData.Id, arrData);
    }
  };

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: ParentBomsService.getAllParentBoms(),
      callback: (response) =>
        setParentBoms(filteredItemInArray(response, "Bom_Type", "DRAFT"))
    });
  }, []);

  return (
    <>
      <Form noValidate validated={validated} onSubmit={handleValidated}>
        <CardDisplayComponent
          body={{
            as: Row,
            element: inputField.map(
              ({
                name,
                label,
                type,
                options,
                size,
                noneAsync,
                minKeywordLength,
                findValue,
                filterBy
              }) => (
                <Col key={name} sm={size || 3}>
                  {type === "select" ? (
                    <SearchSelectComponent
                      floatingClass="mb-0"
                      labelField={label}
                      filterBy={filterBy}
                      options={options}
                      placeholder="โปรดเลือก"
                      noneAsync={noneAsync}
                      minKeywordLength={minKeywordLength}
                      isInvalid={!rowData?.[name]}
                      onChange={(change) =>
                        handleChange(name, change?.value || null)
                      }
                      value={`${rowData?.[name]}`}
                    />
                  ) : (
                    <FloatingControlComponent
                      readOnly
                      type="text"
                      name={name}
                      label={label}
                      placeholder="โปรดระบุ"
                      value={autoDisplayValue({
                        name,
                        type,
                        findValue: {
                          ...findValue,
                          value: rowData?.[findValue?.value]
                        }
                      })}
                    />
                  )}
                </Col>
              )
            )
          }}
          footer={{
            className: "text-end",
            element: (
              <>
                <Button
                  type="submit"
                  variant="success"
                  className="me-2 px-5 py-2 text-dark rounded-pill"
                >
                  บันทึกการแก้ไข
                </Button>
                <ConfirmModal
                  show={showModal}
                  data={data}
                  content="edit"
                  onSubmitCallback={handleSubmit}
                />

                <Button
                  variant="outline-success"
                  className="px-5 py-2 text-dark border-dark border-opacity-50 rounded-pill"
                  onClick={() => navigate("/wo_master/BOM", { state: "Bom" })}
                >
                  ยกเลิก
                </Button>
              </>
            )
          }}
        />
      </Form>
    </>
  );
};

ParentBomForm.propTypes = { onSubmitCallback: PropTypes.func };

export default ParentBomForm;
